import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { FieldWrapper } from '@td-client-frontend/common';
import { DatePicker, TextField, Checkbox, Radio } from '../../../components/ReactHookForm';

export function Products({ name }: { name: string }) {
  return (
    <>
      <ProductRow>
        <Product name={`${name}.GM`} label="Gen Med Service">
          <DatePicker name={`${name}.GM.start_dt`} label="Effective Date" required />
          <DatePicker name={`${name}.GM.end_dt`} label="Termination date" />
          <TextField name={`${name}.GM.member_copay`} type="number" label="Member pays" />
        </Product>
        <RadioBlock styles="col-end-8" name={`${name}.could_be_less`} label="Copay may be less" />
        <RadioBlock styles="col-end-8" name={`${name}.app_opt_out`} label="USGH APP Opt-Out" />
      </ProductRow>
      <ProductRow>
        <Product name={`${name}.DERM`} label="Derm Service">
          <DatePicker name={`${name}.DERM.start_dt`} label="Effective Date" required />
          <DatePicker name={`${name}.DERM.end_dt`} label="Termination date" />
          <TextField name={`${name}.DERM.member_copay`} type="number" label="Member pays" />
        </Product>
      </ProductRow>
      <ProductRow>
        <Product name={`${name}.BH`} label="Mental Service">
          <DatePicker name={`${name}.BH.start_dt`} label="Effective Date" required />
          <DatePicker name={`${name}.BH.end_dt`} label="Termination date" />
          <TextField name={`${name}.BH.BHINIT`} type="number" label="Initial Psyc" required />
          <TextField name={`${name}.BH.BHMD`} type="number" label="Followup Psyc" required />
          <TextField name={`${name}.BH.BHNPT`} type="number" label="Therapy NonMD" required />
          <Checkbox name={`${name}.BH.enable_adolescent_visits`} label="Enable adolescent visits" />
        </Product>
      </ProductRow>
      <ProductRow>
        <Product name={`${name}.EMS`} label="Expert Service">
          <DatePicker name={`${name}.EMS.start_dt`} label="Effective Date" required />
          <DatePicker name={`${name}.EMS.end_dt`} label="Termination date" />
          <Checkbox name={`${name}.EMS.isEfb`} label="Extended family" />
        </Product>
      </ProductRow>
    </>
  );
}

const ProductRow = ({ children }: { children: ReactNode }) => (
  <div className="grid gap-x-4 grid-cols-7 items-center">{children}</div>
);

const Product = ({ name, children, label }: { name: string; children: ReactNode; label: string }) => {
  const { watch } = useFormContext();
  return (
    <>
      <RadioBlock name={`${name}.isEnabled`} label={label} />
      {watch(`${name}.isEnabled`) === 'true' && <>{children}</>}
    </>
  );
};

const RadioBlock = ({ name, label, styles = '' }: { name: string; label: string; styles?: string }) => {
  return (
    <div className={clsx('self-start', styles)}>
      <FieldWrapper label={label} labelClasses="mb-2 text-sm font-bold">
        <div className="flex gap-4">
          <Radio name={name} id={`${name}.Y`} label="Yes" value="true" />
          <Radio name={name} id={`${name}.N`} label="No" value="false" />
        </div>
      </FieldWrapper>
    </div>
  );
};
